import _Section from "./section";

export const Section = _Section;
